import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { removeToken } from "../../ auth";
import "bootstrap-icons/font/bootstrap-icons.css";
import logo from "../../assets/img/logoN.png";

export default function SidebarAdmin() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const isActive = (path) => location.pathname === path;
  const handleToggle = () => setIsOpen(!isOpen);
  const handleLogout = () => {
    removeToken();
    navigate("/");
  };

  return (
    <>
      {/* Barre horizontale pour mobile */}
      <nav className="d-lg-none bg-dark text-white shadow-sm position-fixed top-0 start-0 end-0" style={{ zIndex: 1000 }}>
        <div className="container-fluid">
          <div className="d-flex align-items-center justify-content-between flex-wrap py-2">
            <div
              className="d-flex align-items-center cursor-pointer"
              onClick={() => navigate("/admin")}
              style={{ cursor: "pointer" }}
            >
              <img src={logo} alt="logo" style={{ height: "40px", marginRight: "10px" }} />
              <span className="fs-6 fw-bold">Admin</span>
            </div>
            <button
              className="btn btn-outline-light"
              type="button"
              onClick={handleToggle}
            >
              <i className={`bi ${isOpen ? "bi-x" : "bi-list"}`}></i>
            </button>
          </div>
          {/* Menu déroulant mobile */}
          <div className={`${isOpen ? "d-block" : "d-none"} pb-2`}>
            <div className="d-flex flex-column gap-2">
              <MobileNavLink 
                icon="people" 
                label="Gérer les utilisateurs" 
                path="/admin/users" 
                isActive={isActive} 
                onClick={() => {
                  navigate("/admin/users");
                  setIsOpen(false);
                }} 
              />
              <MobileNavLink 
                icon="person-check" 
                label="Gérer les élèves" 
                path="/admin/aspirants" 
                isActive={isActive} 
                onClick={() => {
                  navigate("/admin/aspirants");
                  setIsOpen(false);
                }} 
              />
              <MobileNavLink 
                icon="file-earmark-text" 
                label="Visualiser les exigences" 
                path="/admin/proofs" 
                isActive={isActive} 
                onClick={() => {
                  navigate("/admin/proofs");
                  setIsOpen(false);
                }} 
              />
              <MobileNavLink 
                icon="geo-alt" 
                label="Gérer les emplacements" 
                path="/admin/locations" 
                isActive={isActive} 
                onClick={() => {
                  navigate("/admin/locations");
                  setIsOpen(false);
                }} 
              />
              <button 
                className="btn btn-outline-danger btn-sm" 
                onClick={handleLogout}
              >
                <i className="bi bi-box-arrow-left me-1"></i>Déconnexion
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Sidebar vertical pour desktop */}
      <div
        className="d-none d-lg-flex flex-column bg-dark text-white shadow-sm p-3 justify-content-between"
        style={{ width: "250px", minHeight: "100vh", zIndex: 1000 }}
      >
        <div>
          <div
            className="d-flex align-items-center mb-4 cursor-pointer"
            onClick={() => navigate("/admin")}
            style={{ cursor: "pointer" }}
          >
            <img src={logo} alt="logo" style={{ height: "40px", marginRight: "10px" }} />
            <span className="fs-5 fw-bold">Admin</span>
          </div>

          <ul className="nav flex-column">
            <SidebarLink icon="people" label="Gérer les utilisateurs" path="/admin/users" isActive={isActive} onClick={() => navigate("/admin/users")} />
            <SidebarLink icon="person-check" label="Gérer les élèves" path="/admin/aspirants" isActive={isActive} onClick={() => navigate("/admin/aspirants")} />
            <SidebarLink icon="file-earmark-text" label="Visualiser les exigences" path="/admin/proofs" isActive={isActive} onClick={() => navigate("/admin/proofs")} />
            <SidebarLink icon="geo-alt" label="Gérer les emplacements" path="/admin/locations" isActive={isActive} onClick={() => navigate("/admin/locations")} />
          </ul>
        </div>

        <div className="border-top pt-3 mt-3">
          <button className="btn btn-outline-danger w-100" onClick={handleLogout}>
            <i className="bi bi-box-arrow-left me-2"></i>Déconnexion
          </button>
        </div>
      </div>
    </>
  );
}

function SidebarLink({ icon, label, path, isActive, onClick }) {
  return (
    <li className="nav-item mb-3">
      <button
        className={`btn text-start text-white w-100 ${isActive(path) ? "fw-bold" : ""}`}
        onClick={onClick}
      >
        <i className={`bi bi-${icon} me-2`}></i>{label}
      </button>
    </li>
  );
}

function MobileNavLink({ icon, label, path, isActive, onClick }) {
  return (
    <button
      className={`btn text-white text-start w-100 ${isActive(path) ? "fw-bold bg-secondary" : ""}`}
      onClick={onClick}
    >
      <i className={`bi bi-${icon} me-2`}></i>{label}
    </button>
  );
}
